import React, { useEffect, useState } from "react";
import useTable from "../../../../../components/useTable";
import axios from 'axios';
import { Input } from "../../../../../ui/inputs/Input";
import { InfoButton, WarningButton } from "../../../../../ui/buttons/Button";
import { ModalValorConstante } from "../modals/modalAgregarConstNomina"

const headCells = [
  {
    id: "codConcepto",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cod. Constante",
    textAlign: "center",
  },
  {
    id: "nombre",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nombre",
    textAlign: "center",
  },
  {
    id: "valor",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Valor Actual",
    textAlign: "right",
  },
];

export default function TablaConstantesNomina(props) {
  var op = require('../../../../../../src/modulos/datos');

  let token = localStorage.getItem('jwtToken');
  const [activate, setActivate] = useState(false);
  const [values, setValues] = useState({
    codcons: '',
    valcons: 0
  });
  const [records, setRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [operacion, setOperacion] = useState(0)
  // Estados para el modal de edición de valor
  const [modalValorVisible, setModalValorVisible] = useState(false);
  const [modalValorOperacion, setModalValorOperacion] = useState(2); // 2: editar, 4: consultar
  const [constanteParaEditar, setConstanteParaEditar] = useState(null);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      if (searchTerm === '') return items;

      return items.filter(item =>
        item.codcons?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.nomcons?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    },
  });

  // Estado para mensajes
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: '',
    texto: '',
    icono: ''
  });

  // Actualizar filterFn cuando cambia searchTerm
  useEffect(() => {
    setFilterFn({
      fn: (items) => {
        if (searchTerm === '') return items;

        return items.filter(item =>
          item.codcons?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.nomcons?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      },
    });
  }, [searchTerm]);

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    records,
    headCells,
    filterFn
  );

  // Función para formatear montos
  const formatearMonto = (valor) => {
    if (valor === null || valor === undefined) return "0,00";
    const numero = typeof valor === 'string' ? parseFloat(valor) : valor;
    return numero.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const seleccionarConstantes = (codIntegrante) => {
    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');

    let id = codIntegrante;
    let nomtab1 = 'constantesinteg';
    let nomtab2 = 'constantes';
    let nomid1 = 'codcons';
    let nomid2 = 'codint';
    let condi = codIntegrante;
    let orden = 1;
    let bloquear = false; // No bloquear para consulta
    let esquema = `nomi${codigoNomina}`;

    let endpoint = `${op.conexion}/api/nomina/seleccionartblesquema?id=${id}&nomtab1=${nomtab1}&nomtab2=${nomtab2}&nomid1=${nomid1}&nomid2=${nomid2}&condi=${condi}&orden=${orden}&bloquear=${bloquear}&esquema=${esquema}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          console.log('Constantes cargadas:', response.data);
          // Mapear los datos para incluir el valor formateado
          const datosFormateados = response.data.map(item => ({
            ...item,
            valcons_formateado: formatearMonto(item.valcons || item.moncons || 0)
          }));
          setRecords(datosFormateados);
        }
      })
      .catch(error => {
        setMensaje({
          mostrar: true,
          titulo: 'Error',
          texto: error.response?.data?.message || 'Error al cargar las constantes',
          icono: 'error'
        });
        setTimeout(() => setMensaje({ ...mensaje, mostrar: false }), 3000);
      })
      .finally(() => setActivate(false));
  };

  useEffect(() => {
    if (props.codIntegrante) {
      seleccionarConstantes(props.codIntegrante);
    }
  }, [props.codIntegrante]);

  const seleccionarFila = (item) => (e) => {
    e.preventDefault();
    setValues({
      codcons: item.codcons,
      valcons: item.valcons || item.moncons || 0
    });
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // Función para consultar valor de constante
  const handleConsultar = () => {
    if (!values.codcons) {
      alert('Seleccione una constante para consultar');
      return;
    }

    setOperacion(4)

    // Buscar la constante completa en records
    const constante = records.find(r => r.codcons === values.codcons);
    if (constante) {
      setConstanteParaEditar({
        codcons: constante.codcons,
        nomcons: constante.nomcons,
        valor: constante.valcons || constante.moncons || 0
      });
      setModalValorOperacion(4); // Modo consultar
      setModalValorVisible(true);
    }
  };

  // Función para editar valor de constante
  const handleEditar = () => {
    if (!values.codcons) {
      alert('Seleccione una constante para editar');
      return;
    }

    setOperacion(2)

    // Buscar la constante completa en records
    const constante = records.find(r => r.codcons === values.codcons);
    if (constante) {
      setConstanteParaEditar({
        codcons: constante.codcons,
        nomcons: constante.nomcons,
        valor: constante.valcons || constante.moncons || 0
      });
      setModalValorOperacion(2); // Modo editar
      setModalValorVisible(true);
    }
  };

  // Función para manejar la respuesta del modal de valor
  const handleModalValorAceptar = async (datos) => {
    console.log('Valor actualizado:', datos);

    try {
      let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
      let esquema = `nomi${codigoNomina}`;

      // Llamar al endpoint para actualizar el valor de la constante
      let endpoint = `${op.conexion}/api/nomina/actualizarvalorconstante?operacion=${operacion}`;

      const payload = {
        p_esquema: esquema,
        p_codint: props.codIntegrante,
        p_codcons: datos.codcons,
        p_valor: datos.valor,
      
      };

      const response = await axios.post(endpoint, payload, {
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        setMensaje({
          mostrar: true,
          titulo: 'Éxito',
          texto: 'Valor actualizado correctamente',
          icono: 'success'
        });

        // Recargar las constantes para mostrar el nuevo valor
        seleccionarConstantes(props.codIntegrante);

        // Limpiar selección
        setValues({ codcons: '', valcons: 0 });
      }
    } catch (error) {
      console.error('Error al actualizar valor:', error);
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || 'Error al actualizar el valor',
        icono: 'error'
      });
    }

    setTimeout(() => setMensaje({ ...mensaje, mostrar: false }), 3000);
    setModalValorVisible(false);
  };

  return (
    <div className="col-12 m-0 p-0 d-flex flex-wrap">
      {/* Mensaje de alerta */}
      {mensaje.mostrar && (
        <div className={`alert alert-${mensaje.icono === 'error' ? 'danger' : 'success'} col-12 mb-2`}>
          {mensaje.texto}
        </div>
      )}

      <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
        <div className="col-12 m-0 p-0">
          <Input
            label="Buscar..."
            value={searchTerm}
            onChange={handleSearch}
            placeholder="Buscar por código o nombre..."
          />
        </div>
      </div>

      <div className="col-11 m-0 p-0">
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <TblContainer>
            <TblHead />
            <tbody>
              {records && records.length > 0 ? (
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: 'pointer',
                      background: values.codcons === item.codcons ? "lightskyblue" : "white"
                    }}
                    onClick={seleccionarFila(item)}
                  >
                    <td className="text-center">{item.codcons}</td>
                    <td className="text-center">{item.nomcons}</td>
                    <td className="text-end">{formatearMonto(item.valcons || item.moncons || 0)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center py-3">
                    No hay constantes registradas para este integrante
                  </td>
                </tr>
              )}
            </tbody>
          </TblContainer>
        </div>
      </div>

      <div className="col-1 m-0 p-0 d-flex flex-column gap-2 align-items-center justify-content-center">
        <div className="col-auto m-0 p-0">
          <InfoButton
            icon="fa-eye m-0"
            onClick={handleConsultar}
            disabled={!values.codcons}
            title="Consultar valor"
          />
        </div>
        <div className="col-auto m-0 p-0">
          <WarningButton
            icon="fa-edit m-0"
            onClick={handleEditar}
            disabled={!values.codcons}
            title="Editar valor"
          />
        </div>
      </div>

      {/* Modal para editar/consultar valor de constante */}
      <ModalValorConstante
        show={modalValorVisible}
        onHide={() => setModalValorVisible(false)}
        operacion={modalValorOperacion}
        datos={constanteParaEditar}
        codIntegrante={props.codIntegrante}
        nomIntegrante={props.nomIntegrante}
        onAceptar={handleModalValorAceptar}
      />
    </div>
  );
}